import { Button, message, Modal, Spin, Tooltip } from "antd";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { MdOutlineSmartToy } from "react-icons/md";
import { aivGetLists } from "../lib/aiv/list/aivGetLists";
import { FaCheck } from "react-icons/fa";
import { BiSolidError } from "react-icons/bi";
import { aivUploadListFunilize } from "../lib/aiv/list/aivUploadListFunilize";
import { usePostHog } from "posthog-js/react";

interface AivContextType {
  selectedList: string | undefined;
  setSelectedList: (value: string) => void;
  sendToAivButton: (modal: boolean, record: object) => JSX.Element | null;
  options: AivOption[];
  setUpdateAivConnections: (value: number) => void;
  setSelectedListAiv: (value: object) => void;
}

interface AivOption {
  label: string;
  value: string;
}

const AivContext = createContext({} as AivContextType);

export const AivProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

  const [options, setOptions] = useState<AivOption[]>([]);
  const [updateAivConnections, setUpdateAivConnections] = useState<number>(Math.random());
  const [selectedListAiv, setSelectedListAiv] = useState<object | undefined>(undefined);
  const [loadingAiv, setLoadingAiv] = useState<boolean>(false);
  const [sendingRecord, setSendingRecord] = useState<object[]>([]);
  const [successfulysentLeads, setSucessfulySentLeads] = useState<object[]>([]);
  const [failedToSendLeads, setFailedToSendLeads] = useState<object[]>([]);
  const posthog = usePostHog();
  useEffect(() => {
    aivGetLists().then((data) => {
      if (data.statusCode !== 200) return;
      
      const list = data.body.filter(list =>(list.tipo_lista === "outbound_funilize")).map((list: any) => ({
        value: list.id_lista,
        label: list.nome_lista,
      }));
      setOptions(list);
    });
  }, [updateAivConnections]);

  const [selectedList, setSelectedList] = useState<string | undefined>(undefined);

  const RenderSendToAivIcon: React.FC<{ modal: boolean; listName: string; record: object }> = ({ modal, listName, record }) => {
    const [modalVisibility, setModalVisibility] = useState<boolean>(false);
    const selectedOption = options.find((option) => option.value === selectedList);

    const sendToAiv = () => {
      setLoadingAiv(true);
      setSendingRecord([...sendingRecord, record]);

      aivUploadListFunilize(selectedListAiv ? selectedListAiv.path : localStorage.getItem('leadPath'),selectedOption?.value || '',record.cnpj_completo).then(response=>{
        if(response.statusCode === 200){
          if(record.cnpj_completo){
            message.success('Lead enviado com sucesso')
          }
          else{
            message.success('Lista enviada com sucesso')
          }
          setSucessfulySentLeads([...successfulysentLeads,record])
        }
        else{
          message.error(response.body)
          setFailedToSendLeads([...failedToSendLeads,record])
        }
        setLoadingAiv(false)
        setSendingRecord(sendingRecord.filter(value=>(value !== record)))
        
      })
    };

    return (
      <div>
        <Tooltip title="Enviar para AIV">
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            {loadingAiv && sendingRecord.includes(record) ? (
              <Spin />
            ) : (
              <Button
                icon={<MdOutlineSmartToy />}
                  onClick={() => {
                    posthog.capture('send_to_aiv_clicked_botao');
                    if (modal) {
                      setModalVisibility(true);
                    } else {
                      sendToAiv();
                    }
                  }}
                type="link"
                style={{ padding: 0 }}
              />
            )}
            {successfulysentLeads.includes(record) ? (
              <FaCheck color="#249882" />
            ) : failedToSendLeads.includes(record) ? (
              <BiSolidError color="#fe6556" />
            ) : null}
          </div>
        </Tooltip>
        <Modal
          title="Confirmar Envio"
          open={modalVisibility}
          onCancel={() => {
            posthog.capture('send_to_aiv_modal_cancel_botao')
            setModalVisibility(false)}}
          onOk={() => {
            posthog.capture('send_to_aiv_modal_confirm_botao')
            sendToAiv();
            setModalVisibility(false);
          }}
        >
          <p>Deseja enviar {listName} para {selectedOption?.label}?</p>
        </Modal>
      </div>
    );
  };

  const sendToAivButton = (modal: boolean, record: object) => {
    return options.find((option) => option.value === selectedList) === undefined ? null : (

      <RenderSendToAivIcon modal={modal} listName={selectedListAiv ? selectedListAiv.id : localStorage.getItem('leadId')}  record={record} />
    );
  };

  return (
    <AivContext.Provider
      value={{
        selectedList,
        setSelectedList,
        sendToAivButton,
        options,
        setUpdateAivConnections,
        setSelectedListAiv
      }}
    >
      {children}
    </AivContext.Provider>
  );
};

export const useAiv = () => useContext(AivContext);
